import React from "react";
import "./Man_Behind_The_Power.css";
import { FaInstagram, FaFacebookF, FaTwitter } from "react-icons/fa";
import {
  faFacebookF,
  faInstagram,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ManBehindPowers } from "../../../utils/apis/aboutus/Aboutus.js";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

const Man_Behind_The_Power = () => {
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [manbehindpower, setManBehindPower] = useState({});

  const getManBehindPower = async () => {
    const res = await ManBehindPowers();

    if (res?.success) {
      setManBehindPower(res?.data?.data?.[0] || {});
    }
  };

  useEffect(() => {
    getManBehindPower();
  }, []);

  return (
    <section className="power-section">
      <div className="power-container">
        <div className="power-left">
          <div className="vertical-text">Founder</div>
         <div className="bg-image">
          <img
            src={IDS?.IMG_URL + manbehindpower?.image}
            alt="Founder"
            className="man-image"
          />
          </div>
        </div>

        <div className="power-right">
          <h2 className="title">The Visionary Behind the Experience</h2>

          <div className="text_content">
            <h4 className="subtitle">{manbehindpower?.position}</h4>
            <p className="name">{manbehindpower?.name}</p>

            <div className="social-icons">
              {[
                { icon: faFacebookF, link: "https://www.facebook.com" },
                { icon: faInstagram, link: "https://www.instagram.com" },
                { icon: faXTwitter, link: "https://www.twitter.com" },
              ].map((item, index) => (
                <a
                  key={index}
                  href={item.link}
                  className="social_link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={item.icon} className="social-icon" />
                </a>
              ))}
            </div>

            <p className="description">
              {htmlToReactParser.parse(manbehindpower?.description)}
            </p>

            <p className="quote">{manbehindpower?.shortdescription}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Man_Behind_The_Power;
